"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SummaryBox;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function SummaryBox(_ref) {
  let {
    title,
    value,
    variant = 'default',
    id,
    icon,
    onIconClick
  } = _ref;
  const theme = (0, _material.useTheme)();
  const summaryBoxStyles = (0, _react.useMemo)(() => {
    switch (variant) {
      case 'default':
        return {
          position: 'relative',
          borderRadius: 8,
          backgroundColor: theme.palette.neutral[200],
          padding: theme.spacing(2)
        };
      case 'available':
        return {
          borderRadius: 8,
          backgroundColor: theme.palette.neutral[700],
          padding: theme.spacing(2),
          color: theme.palette.common.white
        };
      case 'full':
        return {
          borderRadius: 8,
          backgroundColor: theme.palette.neutral[200],
          padding: theme.spacing(2),
          height: '100%',
          boxSizing: 'border-box'
        };
      default:
        return {
          borderRadius: 8,
          backgroundColor: theme.palette.state[5],
          padding: theme.spacing(2),
          color: theme.palette.common.white
        };
    }
  }, [theme, variant]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    id: id,
    sx: summaryBoxStyles
  }, icon && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: onIconClick,
    sx: {
      position: 'absolute',
      right: theme.spacing(2)
    }
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Info, null)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, title), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p",
    variant: "h6",
    sx: {
      fontWeight: theme.typography.fontWeightBold,
      whiteSpace: 'pre-line'
    }
  }, value));
}